import { path } from 'ramda';

export const getLoginErrors = path(['authentication', 'loginError']);
export const getResponseErrors = path(['authentication', 'responseError']);
export const getLoginInformation = path(['authentication', 'loginInformations']);
export const getChallengeInformation = path(['authentication', 'challengeInformations']);
export const getLoggedInStatus = path(['authentication', 'isLoggedIn']);
export const getValidLoginError = path(['authentication', 'validLoginError'])
export const getLogin=path(['authentication', 'login'])